import React from 'react';
import { getTooltipPlacementClasses } from './helpers/getTooltipPlacementClasses';

const tooltipPanelClassName =
  'pointer-events-none invisible absolute z-[10000] w-max max-w-[280px] whitespace-normal break-normal [overflow-wrap:normal] rounded-[5px] bg-[var(--color-text)] px-2.5 py-1.5 text-center text-xs font-semibold leading-[150%] text-[var(--color-surface)] group-hover:visible';

type TProps = {
  children: React.ReactNode;
  content?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
};

export const Tooltip = ({ children, content, placement = 'bottom' }: TProps): React.ReactElement => {
  const placementClasses = getTooltipPlacementClasses(placement);

  return (
    <div className="group relative inline-block overflow-visible">
      {children}
      <div className={`${tooltipPanelClassName} ${placementClasses}`}>{content}</div>
    </div>
  );
};
